"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headline = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
exports.Headline = styled_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 1.2rem 0 2rem;\n    color: ", ";\n    font-size: 3.6rem;\n    line-height: 4.5rem;\n  "], ["\n    margin: 1.2rem 0 2rem;\n    color: ", ";\n    font-size: 3.6rem;\n    line-height: 4.5rem;\n  "])), theme.colors.gray80);
});
var templateObject_1, templateObject_2;
